import { useEffect, useState } from "react";

const DURATION_SECONDS = 17 * 60 + 34;
// Shared start so every timer on the page stays in sync
const START = Date.now();

export function useCountdown() {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const elapsed = Math.floor((now - START) / 1000) % DURATION_SECONDS;
  const remaining = DURATION_SECONDS - elapsed;

  return {
    hours: Math.floor(remaining / 3600),
    minutes: Math.floor((remaining % 3600) / 60),
    seconds: remaining % 60,
  };
}
